module.exports = __webpack_public_path__ + "static/media/VestasSans-Semibold.dd7d7574.woff";